import { Component, ViewChild } from "@angular/core";
import { Nav, Platform, AlertController } from "ionic-angular";
import { AngularFireDatabase } from "angularfire2/database";
import { AngularFireAuth } from "angularfire2/auth";

@Component({
  templateUrl: "app.html",
})
export class KasootAdminApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = "WelcomePage";
  pages: Array<{ title: string; component: any }>;

  isAuth = false;
  user = {};

  constructor(
    public platform: Platform,
    public database: AngularFireDatabase,
    public alertCtrl: AlertController,
    private afAuth: AngularFireAuth
  ) {
    this.checkUser();

    // used for an example of ngFor and navigation
    this.pages = [
      { title: "Jokes", component: "JokesPage" },
      { title: "Team", component: "TeamPage" },
      { title: "Programs", component: "ProgramsPage" },
      { title: "Partners", component: "PartnersPage" },
      { title: "Requests", component: "RequestsPage" },
      { title: "Dictionary", component: "DictionaryPage" },
      { title: "Proverbs", component: "ProverbsPage" },
      { title: "Kavi", component: "WritersPage" },
    ];
  }

  checkUser() {
    this.afAuth.authState.subscribe(
      (user) => this._changeState(user),
      (error) => console.trace(error)
    );
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  logout() {
    this.afAuth.auth.signOut();
    this._changeState();
    this.presentNonAdminAlert();
  }

  presentNonAdminAlert() {
    let alert = this.alertCtrl.create({
      title: "गलत आ बड़ा ",
      subTitle:
        "बात न्यू सै जनाब, यो एडमिन खातर सै, थारे पै या चौधर इब लग आयी कोणी सै",
      buttons: ["राम राम "],
    });

    alert.present();
  }

  private _changeState(user: any = null) {
    console.log({ user });
    if (!user) return this._handleNoUser();

    let dataRef = this.database.object(`admins/${user.uid}`).valueChanges();
    dataRef.subscribe((admin) => {
      if (admin && admin !== null) return this._handleUser(user);
      this.logout();
    });
  }

  private _handleUser(user) {
    this.isAuth = true;
    this.user = this._getUserInfo(user);
    this.rootPage = "RequestsPage";
  }

  private _handleNoUser() {
    this.isAuth = false;
    this.user = {};
    this.rootPage = "WelcomePage";
  }

  private _getUserInfo(user: any): any {
    if (!user) return {};

    let data = user.providerData[0];

    return {
      name: data.displayName,
      avatar: data.photoURL,
      email: data.email,
      provider: data.providerId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts